export default {
  "nav.home": "Inicio",
  "nav.categories": "Categorías",
  "nav.articles": "Guías",
  "nav.faq": "FAQ",
  "nav.shoppingGuide": "Guía de compras",
  "nav.homeBtn": "Inicio",

  "hero.badge": "Recurso de compras independiente",
  "hero.title": "USFans Spreadsheet: encuentra productos, vendedores y recursos de compra más rápido",
  "hero.subtitle": "Explora el USFans Spreadsheet, descubre productos y vendedores, compara recursos útiles y conoce el envío, el almacén, el control de calidad y la seguridad al comprar.",
  "hero.ctaPrimary": "Explorar USFans Spreadsheet",
  "hero.ctaSecondary": "Ver guías",
  "hero.searchPlaceholder": "Busca en USFans Spreadsheet, productos, vendedores o categorías...",

  "cta.usfans": "usfans spreadsheet",
  "cta.buynow": "cómpralo ya",

  "categories.dropdownLabel": "Elige una categoría",
  "categories.title": "Explorar por categoría",
  "categories.subtitle": "Elige una categoría a continuación para ir directo a los productos correspondientes de la tienda principal.",

  "cat.shoes": "Zapatos",
  "cat.hoodies": "Sudaderas / Suéteres",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Chaquetas",
  "cat.pants": "Pantalones / Shorts",
  "cat.headwear": "Gorros",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Ropa interior / Calzoncillos",
  "cat.jersey": "Camiseta deportiva",
  "cat.accessories": "Accesorios",
  "cat.bags": "Bolsos",
  "cat.belts": "Cinturones",
  "cat.perfumes": "Perfumes",
  "cat.other": "Otras cosas",

  "articles.title": "Últimas guías y recursos",
  "articles.subtitle": "Guías originales para ayudarte a comprar de forma más inteligente con USFans Spreadsheet.",
  "articles.readMore": "Leer artículo",
  "articles.minRead": "min de lectura",

  "content.title": "¿Qué es el USFans Spreadsheet?",
  "content.p1": "El USFans Spreadsheet es una referencia práctica que reúne categorías de productos y enlaces de vendedores en un solo lugar. En lugar de buscar por la web, abres una categoría y vas directo a lo que buscas, desde zapatos y sudaderas hasta bolsos, cinturones y fragancias.",
  "content.p2": "Cada categoría apunta a una página dedicada de la tienda principal, por lo que siempre llegas donde están realmente los productos. Esto hace que la navegación sea más rápida y mantiene todo organizado por tipo.",
  "content.cta": "Abrir el USFans Spreadsheet",

  "faq.title": "Preguntas frecuentes",
  "faq.subtitle": "Respuestas rápidas sobre cómo funciona el USFans Spreadsheet.",

  "safety.title": "Compra con confianza",
  "safety.text": "Este es un recurso informativo independiente. Verifica siempre los detalles del producto, los precios y el envío directamente en la tienda antes de comprar.",
  "safety.disclaimer": "USFansLink.club es un recurso informativo independiente y no debe presentarse como el sitio oficial de USFans a menos que se haya verificado una relación oficial.",

  "footer.disclaimer": "USFansLink.club es un recurso informativo independiente y no está afiliado ni respaldado por ninguna tienda mencionada. Todos los enlaces externos se abren en una pestaña nueva.",
  "footer.rights": "Todos los derechos reservados.",

  "article.back": "Volver al inicio",
  "article.updated": "Última actualización",
  "article.pros": "Ventajas",
  "article.cons": "Desventajas",
  "article.faq": "FAQ",
  "article.related": "Guías relacionadas",
  "article.ctaTitle": "¿Listo para explorar?",
  "article.ctaText": "Ve al USFans Spreadsheet y empieza a navegar por productos y vendedores.",
  "article.ctaButton": "Abrir USFans Spreadsheet",
};